import { StepTypeEnum } from '../components/dashboard/admin/workflow/types/workflow.types';

/**
 * Step types that do not require "Find By" and "Selector Value" fields
 */
export const STEP_TYPES_WITHOUT_SELECTOR: StepTypeEnum[] = [
  StepTypeEnum.WAIT,
  StepTypeEnum.CLOSE,
  StepTypeEnum.CAPTCHA,
  StepTypeEnum.NAVIGATE,
  StepTypeEnum.PAUSE,
];

/**
 * Check if a step type requires selector fields
 */
export const requiresSelector = (stepType: StepTypeEnum): boolean => {
  return !STEP_TYPES_WITHOUT_SELECTOR.includes(stepType);
};

/**
 * Step types that do not require "value" field
 */
export const STEP_TYPES_WITHOUT_VALUE: StepTypeEnum[] = [
  StepTypeEnum.CLICK,
  StepTypeEnum.EXTRACT,
  StepTypeEnum.EXTRACT_TABLE,
];

/**
 * Check if a step type requires value field
 */
export const requiresValue = (stepType: StepTypeEnum): boolean => {
  return !STEP_TYPES_WITHOUT_VALUE.includes(stepType);
};
